const path = "/app/alerts";

export const alertsRouteMeta = [
  {
    type: "redirect",
    key: "ALERTS_GENERATED",
    from: path,
    to: `${path}/generated-alerts`,
    exact: true,
  },
  { type: "route", key: "ALERTS_GENERATED", path: `${path}/generated-alerts` },
  { type: "route", key: "ALERT_POLICY", path: `${path}/alert-policy/*` },
  {
    type: "route",
    key: "ALERT_ASSOCIATE_POLICY",
    path: `${path}/associate-alert-policy`,
  },
];
